import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-slate-200'
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-2xl font-bold bg-gradient-to-r from-cyan-600 to-blue-700 bg-clip-text text-transparent hover:from-cyan-500 hover:to-blue-600 transition-all duration-300"
            >
              SUB-ZERO
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-slate-700 hover:text-cyan-600 transition-colors duration-300 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-slate-700 hover:text-cyan-600 transition-colors duration-300 font-medium"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('technology')}
              className="text-slate-700 hover:text-cyan-600 transition-colors duration-300 font-medium"
            >
              Technology
            </button>
            <button
              onClick={() => scrollToSection('specs')}
              className="text-slate-700 hover:text-cyan-600 transition-colors duration-300 font-medium"
            >
              Technical Specs
            </button>
            <button
              onClick={() => scrollToSection('manufacturing')}
              className="text-slate-700 hover:text-cyan-600 transition-colors duration-300 font-medium"
            >
              Manufacturing
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-700 hover:text-cyan-600 transition-colors duration-300 font-medium"
            >
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-6 py-2 transition-all duration-300 shadow-lg shadow-cyan-600/30"
            >
              Get in Touch
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-slate-700 hover:text-cyan-600 transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-slate-200">
          <div className="px-4 pt-4 pb-6 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left px-4 py-3 text-slate-700 hover:text-cyan-600 hover:bg-slate-100 rounded-lg transition-all duration-300"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-3 text-slate-700 hover:text-cyan-600 hover:bg-slate-100 rounded-lg transition-all duration-300"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('technology')}
              className="block w-full text-left px-4 py-3 text-slate-700 hover:text-cyan-600 hover:bg-slate-100 rounded-lg transition-all duration-300"
            >
              Technology
            </button>
            <button
              onClick={() => scrollToSection('specs')}
              className="block w-full text-left px-4 py-3 text-slate-700 hover:text-cyan-600 hover:bg-slate-100 rounded-lg transition-all duration-300"
            >
              Technical Specs
            </button>
            <button
              onClick={() => scrollToSection('manufacturing')}
              className="block w-full text-left px-4 py-3 text-slate-700 hover:text-cyan-600 hover:bg-slate-100 rounded-lg transition-all duration-300"
            >
              Manufacturing
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-3 text-slate-700 hover:text-cyan-600 hover:bg-slate-100 rounded-lg transition-all duration-300"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-cyan-600 hover:bg-cyan-700 text-white font-semibold mt-4 shadow-lg shadow-cyan-600/30"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;